import "rc-slider/assets/index.css";
import "rc-switch/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import "rc-notification/assets/index.css";
import "rc-pagination/assets/index.css";

import "array.prototype.fill";
import "react-app-polyfill/ie11";
import "core-js/features/array/find";
import "core-js/features/array/includes";
import "core-js/features/array/find-index";
import "core-js/features/number/is-nan";
import "core-js/features/string/includes";
import "core-js/features/string/ends-with";
import "core-js/features/string/starts-with";
import "core-js/features/object/values";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import "./index.css";
import "./App.less";
import "./i18n";
import App from "./App";
import { getDefaultLang, isBrowser } from "./utils";

let Cohere = null;
/**
 * https://app.cohere.so/dashboard
 */
if (isBrowser) {
  Cohere = require("cohere-js");
  Cohere.default.init("B694ZrcIstjfNWX3QTuvDobZ");
}

const Entry = () => {
  console.log(getDefaultLang(), "!@^%%R$E");
  return (
    <React.StrictMode>
      <BrowserRouter>
        <ScrollToTop>
          <App
            initData={window._AUTHING_SSR_INIT_STATE_}
            lang={getDefaultLang()}
          />
        </ScrollToTop>
      </BrowserRouter>
    </React.StrictMode>
  );
};

ReactDOM.hydrate(<Entry />, document.getElementById("root"));
